var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C10.9164 16 12.3747 16 13.3969 15.2414C13.7271 14.9964 14.0174 14.6998 14.2573 14.3626C15 13.3184 15 11.8289 15 8.85C15 5.87105 15 4.38157 14.2573 3.3374C14.0174 3.00018 13.7271 2.70363 13.3969 2.45862C12.3747 1.7 10.9164 1.7 8 1.7C5.08354 1.7 3.62531 1.7 2.60305 2.45862C2.27291 2.70363 1.98257 3.00018 1.74271 3.3374C1 4.38157 1 5.87105 1 8.85C1 11.8289 1 13.3184 1.74271 14.3626C1.98257 14.6998 2.27291 14.9964 2.60305 15.2414C3.62531 16 5.08354 16 8 16Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 4.87787V8.05565M11.8889 4.87787V12.8223M4.11108 4.87787V10.439",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloumn);
export default __webpack_public_path__ + "static/media/cloumn.6199fd9cb235de1a8bd9b2c9e47ee8a2.svg";
export { ForwardRef as ReactComponent };